import { observer } from 'mobx-react-lite'
import { type TeamItemViewModel } from '@/features/iam/teams/TeamItemViewModel'
import { links } from '@/utils/link'
import { TeamItem } from '@/features/iam/teams/components/TeamItem'

export interface TeamItemContainerProps {
  vm: TeamItemViewModel
  active?: boolean
}

export const TeamItemContainer = observer(function TeamItemContainer({
  vm,
  active,
}: TeamItemContainerProps) {
  return (
    <TeamItem
      to={vm.team.slug ? links.team(vm.team.slug) : ''}
      active={active}
      name={vm.team.name}
      avatar={vm.team.avatar}
      ownerName={vm.team.owner.member.displayName}
    />
  )
})
